import { useId, useState, type FormEvent } from "react";
import { api, errorText } from "../lib/api";
import { resetSession } from "../lib/session";
import { Button, Field, Input, Notice } from "./ui";

const CONFIRM_WORD = "SUPPRIMER";

/** "Zone dangereuse": irreversible account deletion, guarded by typing SUPPRIMER. */
export function DeleteAccount() {
  const inputId = useId();
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const ready = typed.trim() === CONFIRM_WORD;

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!ready || busy) return;
    setBusy(true);
    setError(null);
    try {
      await api("DELETE /api/me", { body: { confirm: CONFIRM_WORD } });
      resetSession();
      // Full navigation: nothing from the deleted account survives in memory.
      window.location.replace("/connexion");
    } catch (err) {
      setError(errorText(err));
      setBusy(false);
    }
  }

  return (
    <div>
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="flex min-h-11 w-full items-center py-[11px] text-left text-[15px] text-danger transition hover:opacity-80"
      >
        Supprimer mon compte
      </button>
      {open ? (
        <form onSubmit={submit} noValidate className="space-y-3 pb-4">
          <p className="text-[13.5px] text-muted">Tout est effacé : conversations, mémoire, missions, ordinateurs, fichiers. C'est définitif.</p>
          <Field label={`Tape ${CONFIRM_WORD} pour confirmer`} htmlFor={inputId}>
            <Input
              id={inputId}
              value={typed}
              autoComplete="off"
              autoCapitalize="characters"
              spellCheck={false}
              maxLength={20}
              className="max-w-xs"
              onChange={(e) => setTyped(e.target.value)}
            />
          </Field>
          <div className="flex flex-wrap gap-2">
            <Button type="submit" variant="danger" busy={busy} disabled={!ready}>
              Supprimer définitivement
            </Button>
            <Button
              variant="ghost"
              disabled={busy}
              onClick={() => {
                setOpen(false);
                setTyped("");
                setError(null);
              }}
            >
              Annuler
            </Button>
          </div>
          {error ? (
            <Notice tone="danger" role="alert">
              {error}
            </Notice>
          ) : null}
        </form>
      ) : null}
    </div>
  );
}
